



























































interface IformData {
  username: string;
  password: string;
  loginType: string;
}
import { Component, Ref, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import { login } from '@/utils/api';

@Component({
  components: {},
})
export default class Login extends Vue {
  formData: IformData = {
    username: '',
    password: '',
    loginType: 'PASSWORD',
  };
  rules: object = {
    username: [
    { required: true, message: '请输入账号', trigger: 'blur' },
    { pattern: /^[^\u4e00-\u9fa5]+$/, message: '请输入正确的账号', trigger: ['blur','change'] }
    ],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
  };
  showVerify: boolean = false;

  //执行登录
  execLogin({ username, password }, params) {
    const _self = this;
    login({ username, password }, params)
      .then((res) => {
        localStorage.setItem('authToken', res.data.tokenValue);
        localStorage.setItem('tenantId', res.data?.claims['tenant-id'] || '');
        localStorage.setItem('partnerId', res.data?.claims['tenant-partner-id'] || '');
        localStorage.setItem('business_model', res.data?.claims?.business_model || 'CLOSE')
        this.$store.dispatch('BUSINESS_MODEL');
        this.getUserInfo();
        this.getOwnDecorationStyle();
        this.getPermission();
        this.$message.success('登录成功!');
        _self.$router.push('/');
      })
      .catch((error) => {
        console.error(error);
      });
  }

  get supplierBackendName(){
    return this.$store.state.decoration?.supplierBackendName || '供应商后台';
  }

  get logoUrl(){
    return this.$store.state.decoration?.loginPlatformLogo || require('@/assets/image/theme/logo.png');
  }

  /*
   *@description:'获取登录账号信息'
   */
  getUserInfo() {
    this.$store.dispatch('A_GET_USERINFO');
  }

  getOwnDecorationStyle() {
    this.$store.dispatch('A_GET_DECORATION')
  }

  isNewHost(){
    return location.hostname == 'vsp-jybs.jd.com';
  }

  /*
   *@description:'获取用户权限'
   */
  getPermission() {
    this.$store.dispatch('A_GET_PERMISSION_TREE');
  }

  submit() {
    (this as any).$refs['loginForm']['validate']((valid) => {
      if (valid) {
        this.showVerify = true;
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  handleSuccess(code) {
    this.showVerify = false;

    const params = {
      captchaVerification: code.captchaVerification,
      loginType: this.formData.loginType,
    };
    this.execLogin(this.formData, params);
  }

  close() {
    this.showVerify = false;
  }
}
